<ng-container *ngIf="value as value">
  <label
    *ngIf="isShowLabel"
    tuiProgressLabel
    class="progress-label"
  >
    {{ value }}%
    <progress
      tuiProgressBar
      new
      [value]="value"
      [max]="max"
      [size]="size"
      [color]="color"
    >
    </progress>
  </label>

  <progress
    *ngIf="!isShowLabel"
    tuiProgressBar
    new
    [value]="value"
    [max]="max"
    [size]="size"
    [color]="color"
  >
  </progress>
</ng-container>
